<template>
  <div class="ide-file-editor" :class="{ readonly: readOnly }">
    <!-- 图片 -->
    <template v-if="file[viewTypeKey] === 'IMAGE'">
      <div class="image-preview">
        <img :src="file.url" alt="图片错误" />
      </div>
    </template>
    <!-- 文件 -->
    <template v-else-if="file[viewTypeKey] === 'FILE'">
      <div class="file-preview">
        <i class="icon none"></i>
        <p style="-webkit-box-orient: vertical;">
          {{ file.name }}
        </p>
      </div>
    </template>
    <!-- 代码 -->
    <template v-else>
      <!-- 页签 -->
      <ul class="tabs" v-if="withTabs">
        <li :class="{active: tab === 'code'}" @click="setTab('code')">代码</li>
        <li :class="{active: tab === 'props'}" @click="setTab('props')">模版属性</li>
      </ul>
      <div class="tab-content">
        <!-- 代码部分 -->
        <CodeEditor
          ref="codeEditor"
          v-show="tab === 'code'"
          v-model="file.content"
          :read-only="readOnly"
          @change="change(file)"
          @save="$emit('save', file)"
        />
        <PropTable :props="file.props" @change="change(file)"/>
      </div>
    </template>
  </div>
</template>

<script>
import CodeEditor from './code-editor/index'
import PropTable from '../prop/PropTable'
export default {
  name: 'FileEditor',
  components: { PropTable, CodeEditor },
  props: {
    // 模版文件对象
    file: {
      type: Object,
      require: true
    },
    // 选中的tab（code代码，props属性，desc描述）
    selectedTab: {
      default: 'code'
    },
    // 是否只读
    readOnly: {
      type: Boolean,
      default: false
    },
    // 是否需要文件页签
    withTabs: {
      type: Boolean,
      default: true
    },
    // viewType字段
    viewTypeKey: {
      require: true
    }
  },
  data () {
    return {
      tab: this.selectedTab,
      // 蒙板
      thePanel: {
        content: '',
        open: false
      },
      // 是否展示系统属性列表
      showSystemPropsTable: false
    }
  },
  methods: {
    // 重新调整大小
    resize () {
      this.$refs.codeEditor && this.$refs.codeEditor.resize()
    },
    // 隐藏
    hide () {
      this.$refs.codeEditor && this.$refs.codeEditor.hide()
    },
    // 显示
    show () {
      this.$refs.codeEditor && this.$refs.codeEditor.show()
    },
    // 切换tab
    setTab (tab) {
      this.tab = tab
      if (tab === 'code') {
        this.resize()
      }
    },
    // 标记文字
    markWords (word) {
      this.$refs.codeEditor && this.$refs.codeEditor.markWords(word)
    },
    // 内容变更
    change (file) {
      file.__isEdited = true
      this.$emit('change', file)
    }
  }
}
</script>

<style scoped lang="scss">
@import "../variables";
.ide-file-editor {
  height: 100%;
  position: relative;
  background-color: $code-space-background;
  overflow: hidden;
  $tab-height: 22px;
  // 页签
  .tabs {
    list-style: none;
    overflow: hidden;
    border-top: $color-gray;
    font-size: 12px;
    li {
      display: block;
      float: left;
      margin-bottom: 0 !important;
      padding: 0 20px;
      line-height: $tab-height;
      cursor: default;
      user-select: none;
      color: $color-white;
      border-bottom: 2px solid transparent;
      box-sizing: border-box;
      &.active {
        background: #5B6163;
        color: $primary-color;
        border-bottom-color: #35A8C0;
      }
      &:last-of-type {
        border-right: 0;
      }
      &.right {
        float: right;
        padding: 0 3px;
      }
    }
  }
  // 页签内容
  .tab-content {
    position: absolute;
    top: $tab-height + 2;
    bottom: 0;
    left: 0;
    width: 100%;
    & > div {
      height: 100%;
    }
    .desc {
      padding-left: 3px;
    }
    .v-note-wrapper {
      z-index: 101 !important;
    }
    // 模版属性
    .template-props-box {
      background-color: $color-gray - 30;
      padding: 12px;
    }
  }
  // 图片预览
  .image-preview {
    width: 60%;
    height: 100%;
    margin: 0 auto;
    padding: 60px 0;
    flex-direction: column;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  // 文件预览
  .file-preview {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .icon {
      width: 100px;
      height: 100px;
      background-size: 100px;
      position: unset;
    }
    p {
      text-align: center;
      width: 200px;
      line-height: 30px;
      height: 30px;
    }
  }
  // 蒙板
  #thePanel {
    background: rgba(0, 0, 0, 0.65);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    & > div {
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      position: absolute;
      top: 50%;
      left: 0;
      margin-top: -20px;
      user-select: none;
    }
  }
  // 只读
  &.readonly {
    .tab-content {
      top: 0;
    }
  }
}
</style>
